<template>
  <b-container>
    <b-breadcrumb :items="bread" class="mt10"></b-breadcrumb>
    <b-card
      header="共享航次计划信息管理系统"
      header-tag="header"
      align="center"
      header-class="login-header"
      class="form-background"
    >
      <b-row no-gutters style="padding:20px;">
        <div class="form-style">
          <h3 style="font-weight: bold">个人设置</h3>

          <b-tabs pills card vertical style="margin-top:20px">
            <b-tab title="我的信息" :active="index==0">
              <b-form @submit="onSubmit">
                <b-form-group id="input-group-1" label="用户名" label-for="input-1">
                  <b-input-group>
                    <b-form-input disabled id="input-1" v-model="user.username" required></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group
                  id="input-group-2"
                  label="电子邮箱"
                  label-for="input-2"
                  description="请填写您的常用邮箱，此邮箱用于接收系统下发的各类邮件"
                >
                  <b-form-input id="input-2" v-model="user.email" required type="email"></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-2" label="真实姓名" label-for="input-2">
                  <b-form-input id="input-2" v-model="user.realName"></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-2" label="所属单位" label-for="input-2">
                  <b-form-input id="input-2" v-model="user.unit"></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-2" label="手机号" label-for="input-2">
                  <b-form-input id="input-2" v-model="user.mobile"></b-form-input>
                </b-form-group>

                <b-button
                  :disabled="commiting"
                  block
                  type="submit"
                  variant="primary"
                  style="padding:6px 80px; background-color:#0582bb;border:1px solid #006ea7"
                >
                  <b-spinner v-if="commiting" small style="margin-right:20px"></b-spinner>更新
                </b-button>
              </b-form>
            </b-tab>
            <b-tab title="密码修改" :active="index==1">
              <b-form @submit="onSubmitChangePwd">
                <b-form-group id="input-group-1" label="用户名" label-for="input-1">
                  <b-input-group>
                    <b-form-input disabled id="input-1" v-model="user.username" required></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group id="input-group-2" label="原始密码" label-for="input-2">
                  <b-form-input id="input-2" v-model="form.password" required type="password"></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-2" label="新密码" label-for="input-2">
                  <b-form-input id="input-2" v-model="form.newPassword" required type="password"></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-2" label="新密码确认" label-for="input-2">
                  <b-form-input id="input-2" v-model="form.newPassword2" required type="password"></b-form-input>
                </b-form-group>

                <b-button
                  :disabled="commitResetPwd"
                  block
                  type="submit"
                  variant="primary"
                  style="padding:6px 80px; background-color:#0582bb;border:1px solid #006ea7"
                >
                  <b-spinner v-if="commitResetPwd" small style="margin-right:20px"></b-spinner>修改
                </b-button>
              </b-form>
            </b-tab>
          </b-tabs>
        </div>
      </b-row>
    </b-card>
    <!-- LINKS -->
    <link-component class="mt20"></link-component>
  </b-container>
</template>

<script>
import LinkComponent from '../../components/LinkComponent.vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';
import Vue from 'vue';

export default {
  components: { LinkComponent },
  name: 'option',
  props: {},
  computed: {},

  data() {
    return {
      bread: [
        {
          text: '首页',
          href: '/index'
        },
        {
          text: '用户信息'
        }
      ],
      user: {},
      form: {},
      commiting: false,
      commitResetPwd: false,
      index: 0
    };
  },

  activated() {
    this.getUserInfo();
    this.index = this.$route.query.index | 0;
  },

  mounted() {},

  methods: {
    getUserInfo() {
      axiosServer({
        url: urls.userInfo,
        type: 'get'
      })
        .then(resp => {
          if (resp.data.code == 0) {
            this.user = resp.data.user;
          }
        })
        .catch(e => {});
    },

    onSubmitChangePwd(evt) {
      evt.preventDefault();
      if (this.form.newPassword != this.form.newPassword2) {
        this.showSubitError('请确定输入的新密码与确认密码相同');
        return;
      }

      this.commitResetPwd = true;

      axiosServer({
        url: urls.updatePassword,
        params: this.form,
        type: 'post'
      })
        .then(resp => {
          this.commitResetPwd = false;
          if (resp.data.code == 0) {
            this.form = {};
            this.$bvToast.toast('更新成功', {
              title: '提示',
              toaster: 'b-toaster-top-center',
              solid: true,
              appendToast: true,
              variant: 'success',
              autoHideDelay: '2000'
            });
          } else {
            this.showSubitError(resp.data.msg);
          }
        })
        .catch(() => {
          this.commitResetPwd = false;
          this.showSubitError();
        });
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.commiting = true;
      axiosServer({
        url: urls.userInfo,
        params: this.user,
        type: 'post'
      })
        .then(resp => {
          this.commiting = false;
          if (resp.data.code == 0) {
            this.$bvToast.toast('更新成功', {
              title: '提示',
              toaster: 'b-toaster-top-center',
              solid: true,
              appendToast: true,
              variant: 'success',
              autoHideDelay: '2000'
            });
          } else {
            this.showSubitError(resp.data.msg);
          }
        })
        .catch(() => {
          this.commiting = false;
          this.showSubitError();
        });
    },
    showSubitError(msg) {
      this.$bvToast.toast('更新失败 【' + msg + '】', {
        title: '提示',
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: true,
        variant: 'danger',
        autoHideDelay: '3000'
      });
    }
  }
};
</script>

<style scoped>
.login-header {
  font-size: 20px;
  font-weight: bold;
  color: #115ca5;
}

@media (max-width: 575.99px) {
  .form-style {
    text-align: left;
    width: 100%;
  }

  .botton-row {
    margin-bottom: 20px;
  }
}

@media (min-width: 576px) {
  .form-style {
    text-align: left;
    width: 100%;
  }

  .botton-row {
    margin-bottom: 20px;
  }
}

@media (min-width: 768px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 50px;
  }
}

@media (min-width: 992px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 100px;
  }
}

@media (min-width: 1200px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 200px;
  }
}
</style>
